<template>
    <footer class="footer">
        <div class="text-center text-muted">
            LangValues created by <a href="https://github.com/PeterSR">PeterSR</a>
            ·
            Inspired by <a href="https://youtu.be/2wZ1pCpJUIM?t=125" target="_blank">Bryan Cantrill</a>
            ·
            <a href="https://github.com/PeterSR/langvalues">Fork me</a>
        </div>
    </footer>
</template>

<script>
export default {
  name: 'project-footer',
}
</script>

<style>
.footer {
    flex-shrink: 0;

    padding: 1em;

    background-color: #f7f9fa;
}
</style>
